module.exports = __webpack_public_path__ + "media/images/choose/billing_student-7620ca73eff6391f6fc4adfe6a12726f.png";